var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33958 3.6254L3.86624 9.41874C3.65958 9.63874 3.45958 10.0721 3.41958 10.3721L3.17291 12.5321C3.08624 13.3121 3.64624 13.8454 4.41958 13.7121L6.56624 13.3454C6.86624 13.2921 7.28624 13.0721 7.49291 12.8454L12.9662 7.05207C13.9129 6.05207 14.3396 4.91207 12.8662 3.51874C11.3996 2.13874 10.2862 2.6254 9.33958 3.6254Z",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 4.59375C8.71635 6.43375 10.2097 7.84042 12.063 8.02708",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.eb5f2196dbc8cff4dee6377880623675.svg";
export { ForwardRef as ReactComponent };